import { API_GET_LIST_PROFESSIONAL_RFP_NEGOTIATE_LIST_SUCCESS } from '@/actions/ProfessionalRfpNegotiateActionsTs';
const initialState = {
    one: {},
};
/**
 * コンサルタント：案件条件相談
 * @param state
 * @param result
 */
export const professionalRfpNegotiate = (state = initialState, result) => {
    const { meta, payload, type } = result;
    switch (type) {
        /** 一覧取得成功 */
        case API_GET_LIST_PROFESSIONAL_RFP_NEGOTIATE_LIST_SUCCESS: {
            const { id = '' } = meta.requestPayload;
            return Object.assign(Object.assign({}, state), { one: Object.assign(Object.assign({}, state.one), { [id]: payload }) });
        }
        default: {
            return state;
        }
    }
};
